<div
  *ngIf="isReady$ | async"
  class="app-layout-wrapper"
  (click)="closeMenu($event)"
>
  <es-header logo="ExamNow">
    <app-nav *ngIf="loggedIn"></app-nav>
  </es-header>
  <main>
    <div class="main-inner">
      <router-outlet></router-outlet>
    </div>
  </main>
  <es-notification
    [isVisible]="notification.visible"
    [messageText]="notification.message"
    [state]="notification.state"
    (esNotificationClose)="closeNotification()"
  >
  </es-notification>
  <es-footer
    [ngStyle]="showFooter"
    text="{{ 'ExamSoft - All rights reserved.' | translate }}"
    [version]="APP_VERSION"
  >
  </es-footer>
  <es-modal
    id="es-timer-modal"
    *ngIf="showTimer$ | async"
    (esModalClose)="toggleTimer(null)"
  >
    <div class="es-modal-wrap">
      <div class="form-container">
        <label for="timer"><span translate>Enter Seconds</span>:</label>
        <input
          name="timer"
          [(ngModel)]="timerSeconds"
          type="text"
          placeholder="{{ 'Enter Seconds' | translate }}"
        />
      </div>
      <button
        (click)="toggleTimer(timerSeconds)"
        class="action"
        type="submit"
        translate
      >
        Submit
      </button>
    </div>
  </es-modal>
</div>
